import { Outlet } from "react-router";
import { FilterProvider } from "../../../context/FilterProvider";

const ISAAuditFilter = () => {
    return (
        <FilterProvider>
            <Outlet />
        </FilterProvider>
    );
}

export default ISAAuditFilter;